// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.
import "../stylesheets/active_admin";

import "../aa_patch/base" // import "@activeadmin/activeadmin";
import "activeadmin_addons"

import "@fortawesome/fontawesome-free/css/all.css";
import "arctic_admin";

import "controllers"

import * as ActiveStorage from "@rails/activestorage"
import "trix"
import "@rails/actiontext"

import "../inputs/easymde_editor_input"
import "../inputs/amount_input"

ActiveStorage.start()

jQuery.datetimepicker.setLocale("ru")

document.jQuery = jQuery

/////////////////////////////////////////////////////////////
// Совместимость jquery-datetimepicker с jQuery 4.0

// https://api.jquery.com/jquery.isfunction/
jQuery.isFunction = () => typeof X === 'function'

// https://api.jquery.com/jQuery.isArray/#jQuery-isArray-obj
jQuery.isArray = () => Array.isArray()

// https://api.jquery.com/jQuery.type/#jQuery-type-obj
jQuery.type = () => typeof X === 'string'

// https://api.jquery.com/jQuery.trim/#entry-examples
jQuery.trim = (val) => val.trim()

/////////////////////////////////////////////////////////////
